module.exports = __webpack_public_path__ + "static/SLFCspread-7-6b2f474869800761844225e146ee4ebc.jpg";